import { render, staticRenderFns } from "./CampoAnexoBase.vue?vue&type=template&id=8ee6ee28&scoped=true"
import script from "./CampoAnexoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoAnexoBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CampoAnexoBase.vue?vue&type=style&index=0&id=8ee6ee28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee6ee28",
  null
  
)

export default component.exports